import { render, staticRenderFns } from "./CreateUser.vue?vue&type=template&id=ffa772a2&scoped=true"
import script from "./CreateUser.vue?vue&type=script&lang=js"
export * from "./CreateUser.vue?vue&type=script&lang=js"
import style0 from "./CreateUser.vue?vue&type=style&index=0&id=ffa772a2&prod&scoped=true&lang=css"
import style1 from "./CreateUser.vue?vue&type=style&index=1&id=ffa772a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa772a2",
  null
  
)

export default component.exports